import React, { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAutenticacao } from '../../contextos/ContextoAutenticacao';
import ComponenteCarregamento from '../comuns/ComponenteCarregamento';

interface Props {
  children: ReactNode;
}

/**
 * RotaProtegida
 *
 * Wrapper para proteger rotas que exigem autenticação.
 * - Mostra loading enquanto o contexto autenticação estiver carregando
 * - Redireciona para /login salvando a rota de origem no state
 * - Renderiza children quando autenticado
 */
export function RotaProtegida({ children }: Props) {
  const { estaAutenticado, estaCarregando } = useAutenticacao();
  const localizacao = useLocation();

  if (estaCarregando) {
    return <ComponenteCarregamento />;
  }

  if (!estaAutenticado) {
    return <Navigate to="/login" state={{ from: localizacao }} replace />;
  }

  return <>{children}</>;
}
